"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ClearButton = exports.ClearIcon = exports.DownIcon = exports.UpIcon = exports.iconStyles = exports.ListBoxTrigger = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _CaretDown = _interopRequireDefault(require("@paprika/icon/lib/CaretDown"));

var _CaretUp = _interopRequireDefault(require("@paprika/icon/lib/CaretUp"));

var _TimesCircle = _interopRequireDefault(require("@paprika/icon/lib/TimesCircle"));

var _button = _interopRequireDefault(require("@paprika/button"));

var types = _interopRequireWildcard(require("../../types"));

var _triggerSizes;

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var triggerSizes = (_triggerSizes = {}, (0, _defineProperty2["default"])(_triggerSizes, types.SMALL, (0, _styledComponents.css)(["", " height:", ";line-height:", ";"], _stylers["default"].fontSize(-2), _stylers["default"].spacer(3), _stylers["default"].spacer(3))), (0, _defineProperty2["default"])(_triggerSizes, types.MEDIUM, (0, _styledComponents.css)(["", " height:", ";line-height:", ";"], _stylers["default"].fontSize(-1), _stylers["default"].spacer(4), _stylers["default"].spacer(4))), (0, _defineProperty2["default"])(_triggerSizes, types.LARGE, (0, _styledComponents.css)(["", " height:", ";line-height:", ";"], _stylers["default"].fontSize(), _stylers["default"].spacer(5), _stylers["default"].spacer(5))), _triggerSizes);

var triggerStyles = function triggerStyles(_ref) {
  var hasError = _ref.hasError,
      isDisabled = _ref.isDisabled,
      isInline = _ref.isInline,
      isReadOnly = _ref.isReadOnly,
      size = _ref.size;
  return (0, _styledComponents.css)(["", " align-items:center;background-color:", ";border:1px solid ", ";border-radius:", ";box-sizing:border-box;color:", ";display:block;padding:0 50px 0 ", ";position:relative;text-align:left;transition:border-color 0.2s;width:100%;", ";", " ", " ", " ", " [data-pka-anchor=\"raw-button\"]{width:calc(100% - 48px);}"], _stylers["default"].truncateText, _tokens["default"].color.white, _tokens["default"].border.color, _tokens["default"].border.radius, _tokens["default"].color.black, _tokens["default"].space, triggerSizes[size], hasError ? _stylers["default"].errorFormStyles : "", hasError && isInline ? "border-bottom-color: ".concat(_tokens["default"].border.color, ";") : "", isDisabled ? "color: ".concat(_tokens["default"].color.blackLighten60, ";") : "", isReadOnly ? _stylers["default"].readOnlyFormStyles : "");
};

var triggerStylesProps = function triggerStylesProps(_ref2) {
  var isHidden = _ref2.isHidden,
      isInline = _ref2.isInline,
      isReadOnly = _ref2.isReadOnly;

  if (isHidden) {
    return (0, _styledComponents.css)(["border:1px solid ", ";"], _tokens["default"].border.color);
  }

  return isInline || isReadOnly ? (0, _styledComponents.css)(["", " ", ""], triggerStyles, isInline ? (0, _styledComponents.css)(["border-bottom-left-radius:0;border-bottom-right-radius:0;"]) : "") : (0, _styledComponents.css)(["[data-pka-anchor=\"list-box-trigger\"]{", ";}"], triggerStyles);
};

var ListBoxTrigger = _styledComponents["default"].div.withConfig({
  displayName: "Triggerstyles__ListBoxTrigger",
  componentId: "sc-1x0n9kt-0"
})(["position:relative;", ""], triggerStylesProps);

exports.ListBoxTrigger = ListBoxTrigger;

var iconStyles = function iconStyles(_ref3) {
  var isDisabled = _ref3.isDisabled;
  return (0, _styledComponents.css)(["color:", ";font-size:20px;height:100%;pointer-events:none;position:absolute;right:", ";top:0;"], isDisabled ? _tokens["default"].color.blackLighten60 : _tokens["default"].textColor.icon, _tokens["default"].space);
};

exports.iconStyles = iconStyles;
var UpIcon = (0, _styledComponents["default"])(_CaretUp["default"]).withConfig({
  displayName: "Triggerstyles__UpIcon",
  componentId: "sc-1x0n9kt-1"
})(["", ""], iconStyles);
exports.UpIcon = UpIcon;
var DownIcon = (0, _styledComponents["default"])(_CaretDown["default"]).withConfig({
  displayName: "Triggerstyles__DownIcon",
  componentId: "sc-1x0n9kt-2"
})(["", ""], iconStyles);
exports.DownIcon = DownIcon;
var ClearIcon = (0, _styledComponents["default"])(_TimesCircle["default"]).withConfig({
  displayName: "Triggerstyles__ClearIcon",
  componentId: "sc-1x0n9kt-3"
})(["", ""], iconStyles);
exports.ClearIcon = ClearIcon;
var ClearButton = (0, _styledComponents["default"])(_button["default"].Icon).withConfig({
  displayName: "Triggerstyles__ClearButton",
  componentId: "sc-1x0n9kt-4"
})(function (_ref4) {
  var shouldHideCaret = _ref4.shouldHideCaret,
      isDisabled = _ref4.isDisabled;
  return (0, _styledComponents.css)(["height:100%;margin-right:2px;position:absolute;right:", ";top:0;&:hover,&:focus{background-color:transparent;border-color:transparent;}[data-pka-anchor=\"button.icon\"] svg{", " color:", ";font-size:14px;vertical-align:text-top;}"], shouldHideCaret ? 0 : "22px", iconStyles, isDisabled ? _tokens["default"].color.blackLighten60 : _tokens["default"].textColor.icon);
});
exports.ClearButton = ClearButton;
//# sourceMappingURL=Trigger.styles.js.map